import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "quoteProviderPrice";

export const quoteProviderPriceService = {
    updateOnApply,
    updateOnApplyForMortgage
};

function updateOnApply(query: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(query) };
    return fetch(`${API_URL}/${API_NAME}/updateOnApply/`, requestOptions).then(handleResponse);
}
function updateOnApplyForMortgage(id: number, quoteId: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/updateOnApplyForMortgage/?id=${id}&quoteId=${quoteId}`, requestOptions).then(handleResponse);
}

